export default __webpack_public_path__ + "static/media/campcanada.8f5eedb1.jpg";